import { useEffect, useState } from 'react';
import { DragDropContext, DragStart, DragUpdate, DropResult, ResponderProvided } from 'react-beautiful-dnd';
import { connect } from 'react-redux';
import { IDataStorage } from '../../core';
import { FxTranslate } from '../../core/translate';
import { ICardInfo, IGrupo } from './';
import styles from './board.module.scss';
import GrupoComponent from './grupo.component';

export type IProps = {
  storage: IDataStorage;
  t: FxTranslate;

  /** datos completos a meter en el tablero (listado de op's) */
  data: ICardInfo[] | undefined;

  /** grupos a mostrar */
  grupos?: IGrupo[];

  /** cantidad de tarjetas ocultas x grupo */
  grupoCardsHidden?: { id: number, cards: number }[];

  /** devuelve los datos del grupo al que pertenece un elemento de "data" */
  getGrupo: (data:ICardInfo) => IGrupo;

  /** indica que un dato se puede mover a la siguiente lista de id de grupos */
  allowMoveIntoGroups: (data: number) => number[];

  /** Ocurre cuando se suelta una tarjeta */
  onDrop: (id?: string, destination?: IGrupo, sourceIndex?: number, destinationIndex?: number) => void;

  /** Ocurre cuando se hace click sobre la tarjeta para abrirla */
  onOpen: (data?: ICardInfo) => void;
  
  /** Ocurre cuando se pide ver mas tarjetas */
  onShowMoreCards: (idgrupo: number, cant: number) => void;
}

function BoardComponent({ storage, t, 
  data, 
  grupos, grupoCardsHidden, getGrupo, allowMoveIntoGroups, 
  onDrop, onOpen, onShowMoreCards,
} : IProps) {
  const [ gruposBlock, setGruposBlock ] = useState<number[]>([]);
  const [ cards, setCards ] = useState<{ [key:number]: ICardInfo[] }|undefined>(undefined);

  // calcula las cards que le corresponde a cada grupo
  useEffect(()=> {
    let cards : { [key:number]: any[] } = {};
    if (!!grupos && !!data) {
      grupos.forEach(grp => {
        cards[grp.id] = data.filter(d => getGrupo(d).id === grp.id)
      });
    }
    setCards(cards);
  }, [data, getGrupo, grupos]);


  const dragdrop = {
    onDragStart: (start: DragStart, provided: ResponderProvided) => {
      //start.draggableId && start.source.droppableId  (id y grupo)
      // busco los estados a los que NO puede viajar
      const idgrupo = parseInt(start.source.droppableId);
      setGruposBlock(allowMoveIntoGroups(idgrupo));
    },
    onDragEnd: (result: DropResult, provided: ResponderProvided) => {
      // limpio el bloqueo de grupos
      setGruposBlock([]);
  
      // verificar si es posible viajar a este estado
      //result.draggableId // id de la tarjeta
      //result.source.droppableId (estado de partida), result.destination?.droppableId (estado de destino)
      
      onDrop(result.draggableId, grupos?.find(p => `${p.id}` === result.destination?.droppableId), result.source.index, result.destination?.index);
    },
    onDragUpdate(update: DragUpdate, provided: ResponderProvided) { },
  }
  
  return <div className={styles["container"]}>
    <DragDropContext onDragEnd={dragdrop.onDragEnd} onDragStart={dragdrop.onDragStart} onDragUpdate={dragdrop.onDragUpdate} >

      {grupos?.map(grupo => 
        <GrupoComponent 
          key={`${grupo.id}`} t={t} 
          id={grupo.id} 
          title={grupo.nombre} 
          block={gruposBlock.includes(grupo.id)} 
          cards={!!cards ? cards[grupo.id] : []} 
          hiddenCards={grupoCardsHidden?.find(p => p.id === grupo.id)?.cards}
          onOpen={onOpen}
          onShowMoreCards={onShowMoreCards}
        />
      )}

    </DragDropContext>
  </div>;
}

export default connect((s:any) => ({ storage:s.main }))(BoardComponent);
